<app-search></app-search>
<div class="adaptive-grow-1">
    <div class="fluent-container">
        <div class="title-color">
            <h1>LISTA DE OCUPACIÓN</h1>
        </div>
        <br />
        <!-- <div>
            <button id="" class="primary-button" (click)="create()">
                <span class="button-content">
                    <mat-icon>add_circle</mat-icon>Agregar nuevo
                </span>
            </button>
        </div> -->
        <br />
        <section class="table-container mat-elevation-z1" tabindex="0">
            <div class="table-adjustable">
                <table
                    mat-table
                    [dataSource]="
                        (asyncProfession | async)?.results ?? []
                            | paginate
                                : {
                                      id: 'server',
                                      itemsPerPage: limit,
                                      currentPage: page,
                                      totalItems: total,
                                  }
                    "
                >
                    <ng-container matColumnDef="acciones">
                        <th mat-header-cell *matHeaderCellDef>Acciones</th>
                        <td mat-cell *matCellDef="let profession">
                            <div class="action-buttons">
                                <a
                                    (click)="updateProfession(profession)"
                                    class="icon-button"
                                >
                                    <span class="material-symbols-outlined"
                                        ><mat-icon>edit</mat-icon></span
                                    >
                                </a>
                                <a
                                    (click)="eliminate(profession)"
                                    appOnlysuperuser="/profession"
                                    class="icon-button"
                                >
                                    <span class="material-symbols-outlined"
                                        ><mat-icon>delete</mat-icon></span
                                    >
                                </a>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="personalData">
                        <th mat-header-cell *matHeaderCellDef>Usuario</th>
                        <td mat-cell *matCellDef="let profession">
                            {{ profession.outsider?.identificationType }}
                            {{ profession.outsider?.identificationCode }}
                            {{ profession.outsider?.name }}
                            {{ profession.outsider?.lastName }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>Ocupación</th>
                        <td mat-cell *matCellDef="let profession">
                            {{ profession.name }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="isLeader">
                        <th mat-header-cell *matHeaderCellDef>Es lider</th>
                        <td mat-cell *matCellDef="let profession">
                            {{ profession.isLeader ? 'Sí' : 'No' }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="leaderRole">
                        <th mat-header-cell *matHeaderCellDef>Tipo de lider</th>
                        <td mat-cell *matCellDef="let profession">
                            {{ profession.leaderRole }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="companyName">
                        <th mat-header-cell *matHeaderCellDef>
                            Nombre de la compañia
                        </th>
                        <td mat-cell *matCellDef="let profession">
                            {{ profession.companyName }}
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="showColumns"></tr>
                    <tr
                        mat-row
                        *matRowDef="let row; columns: showColumns"
                        class="highlight-row"
                    ></tr>
                </table>
            </div>
        </section>
        <pagination-controls
            (pageChange)="fetchProfession($event)"
            previousLabel="Anterior"
            nextLabel="Siguiente"
            id="server"
        ></pagination-controls>
    </div>
</div>
